import React from 'react';
import './LoadMoreButton.css';

const LOAD_MORE_ICON = '/images/explore/load-more-refresh.svg';

/**
 * Figma-aligned primary “Load More” (single refresh icon on the left, Geist 14 medium).
 */
function LoadMoreButton({
  onClick,
  disabled = false,
  loading = false,
  label = 'Load More',
  loadingLabel = 'Loading...',
  className = '',
}) {
  const isDisabled = disabled || loading;

  return (
    <div className={`load-more-wrap ${className}`.trim()}>
      <button
        type="button"
        className="load-more-btn"
        onClick={onClick}
        disabled={isDisabled}
        aria-busy={loading || undefined}
      >
        <img src={LOAD_MORE_ICON} alt="" className="load-more-btn__icon" width={20} height={20} loading="lazy" decoding="async" />
        <span className="load-more-btn__label">{loading ? loadingLabel : label}</span>
      </button>
    </div>
  );
}

export default LoadMoreButton;
